import axios from 'axios'
import { getCookie, setAuthToken } from '../../product/common/api'
import { decryptData, encryptData } from '../../product/common/tweetnacl'

const requestAuth = async (endpoint, headers) => {
    let res
    try {
        res = await axios.post(
            `${global.site_url}/api/admin/${endpoint}`,
            global.decryptData ? encryptData({}) : {},
            {
                headers,
                withCredentials: true,
                xsrfCookieName: 'XSRF-TOKEN',
                xsrfHeaderName: 'X-CSRF-Token',
                timeout: 15000,
            }
        )
    } catch (err) {
        if (err.code === 'ECONNABORTED') {
            throw new Error('Logout timed out. Please try again.')
        }
        if (err.response) {
            const data = global.decryptData
                ? decryptData(err.response.data)
                : err.response.data
            throw new Error(
                data?.message || 'Unable to log out. Please try again.'
            )
        }
        throw err
    }

    return global.decryptData ? decryptData(res.data) : res.data
}

export const logoutAndRedirect = async () => {
    const csrfToken = getCookie('XSRF-TOKEN') || getCookie('csrfToken')
    const headers = { 'content-type': 'application/json' }
    if (csrfToken) headers['X-CSRF-Token'] = csrfToken

    if (!csrfToken && !axios.defaults.headers.common['Authorization']) {
        const validation = await requestAuth('validateUser', headers)
        const sessionIsInvalid =
            validation?.status === 'error' &&
            [401, 403].includes(validation?.data?.responseType)
        if (!sessionIsInvalid) {
            throw new Error(
                'Security validation failed. Refresh the page and try again.'
            )
        }
    } else {
        const data = await requestAuth('logout', headers)
        if (data?.status !== 'success') {
            throw new Error(
                data?.data?.message || 'Unable to log out. Please try again.'
            )
        }
    }

    localStorage.removeItem('token')
    localStorage.removeItem('userId')
    localStorage.removeItem('oktaToken')
    sessionStorage.removeItem('token')
    sessionStorage.removeItem('userId')
    setAuthToken(null)

    // Reset in-memory auth and pending dashboard work, not just the SPA route.
    window.location.replace(
        process.env.REACT_APP_OKTA_SIGNIN === 'true' ? '/logout' : '/'
    )
}
